module.exports = __webpack_public_path__ + "img/65779.15a56a57.png";